<div class="exception-body">

    <div class="exception-topbar">
        <a href="#" class="logo">
            <img src="assets/layout/images/sf-logoTabellio.png" style="margin: auto; width: 64px;" alt="Tabellio"/>
        </a>
    </div>

    <img class="exception-image" src="assets/layout/images/image-access.png" alt="Tabellio" />

    <div class="exception-panel">
        <img class="exception-icon" src="assets/layout/images/icon-access.png" alt="Tabellio" />
        <h1 class="exception-summary">Acesso Negado</h1>
        <p class="exception-detail">
            Desculpe, mas você não tem permissão para acessar esta página.<br>
            Clique no botão abaixo para retornar ao painel principal.
        </p>
        <div>
            <button type="button" pButton label="Painel Principal" [routerLink]="['/']"></button>
        </div>
    </div>
</div>
